module.exports = __webpack_public_path__ + "static/media/mineS.e7452fe6.jpg";